import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { PwaHandshakeService } from '../pwa-handshake.service';
import { AuthService } from '../transaction/auth.service';
import { TransactionService } from '../transaction/transaction.service';
import { Amount, Currency, DiasporaStagingResponse, FlowCode, OrchestrationRequest, StatusMode } from '../general.model';
import { InstantBankTransferService } from '../instant-bank-transfer.service';
import { Action } from 'rxjs/internal/scheduler/Action';

@Component({
  selector: 'app-transfer-successful',
  standalone: true,
  imports: [CommonModule,ButtonModule],
  templateUrl: './transfer-successful.component.html',
  styleUrl: './transfer-successful.component.css'
})
export class TransferSuccessfulComponent implements OnInit{


  constructor(private router:Router,
    private pwaHandshakeService:PwaHandshakeService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private transactionService:TransactionService,
    private instantBankTransferService:InstantBankTransferService  
  ) {
    
  }
  ngOnInit(): void {
    const correlatorId = this.route.snapshot.queryParamMap.get('correlatorId') || '';

    this.authService.uuid.set(correlatorId);
    this.getTransaction();
  }
  retry() {
    this.router.navigate(['/unavailable']);
    console.log('Retry clicked');
  }

  done() {
    this.pwaHandshakeService.done();
  }

  getTransaction(){
        console.log('Proceed');
        let amount:Amount = {currency:this.instantBankTransferService.data()?.currency as Currency,
          value:this.instantBankTransferService.data()?.amount};
        
        let confirmTransactionResponse = this.authService.confirmTransactionResponse();
        this.transactionService.getPayment(this.authService?.uuid() ?? '', StatusMode.SAVED).subscribe({
            next: (response) => {
                let diasporaStagingResponse:DiasporaStagingResponse = response;
                this.transaction = diasporaStagingResponse;
                console.log('Data received:', response);
            },
            error: (err) => {
                this.router.navigate(['/service-unavailable']);
                console.error('Error occurred:', err);
            }
        });
    
  }
  
  transaction!:DiasporaStagingResponse;
}
